export function scrollToAnchors() {
    const $body = $("html, body");
    const $hash = window.location.hash.replace(/\//g, "");
    const $header = $(".header");
    
    $(window).on("load", function () {
        
        if ($($hash).length) {
            $body.stop().scrollTop(($($hash).offset().top - $header.innerHeight()));alert('$hash');
        } else {
            // setTimeout( function () { scroll(0,0); }, 1);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scroll-to-anchors.js